export default __webpack_public_path__ + "static/media/logoImpactools.f68d12c6.svg";